import Vue from "vue";

Vue.component("provisional-has-dms-record", {
	props: ["notificationId", "crnNumber", "notifyingMember"],
	data() {
		return {
			loading: false,
			loadingText: window.labels.loading,
			hasDMSRecord: false
		};
	},
	methods: {
		checkDMSRecord: function () {
			this.loading = true;
			this.$services.notifications.checkDMSRecord({
					notificationId: this.notificationId
				})
				.then((data) => {
					this.loading = false;
					this.hasDMSRecord = data;
				});
		},
	},
	mounted() {
		this.checkDMSRecord();
	},
	template: `
	<div>
		<div v-if="loading">
			<loading :loading-text="loadingText"></loading>
		</div>
		<div v-else-if="hasDMSRecord">
          <div v-if="crnNumber" v-html="crnNumber" style="color: #3abb67"></div>
          <div v-if="notifyingMember" v-html="notifyingMember" style="color: #3abb67"></div>
		</div>
        <div v-else>
          <div v-if="crnNumber" v-html="crnNumber"></div>
          <div v-if="notifyingMember" v-html="notifyingMember"></div>
        </div>
	</div>
	`
});